import { action, computed, makeObservable, override, runInAction } from 'mobx'
import { EntityTypeStore } from '@migrate/stores/EntityTypeStore'
import { HyperMediaStore } from '@migrate/stores/HyperMediaStore'
import LoadableStore, { LoadingState } from '@migrate/stores/LoadableStore'
import { CategoryStore } from '@migrate/stores/CategoryStore'

export default class SharedStore extends LoadableStore {
  public static STORE_NAME = 'sharedStore'

  entityTypeStore: EntityTypeStore
  hyperMediaStore: HyperMediaStore
  categoryStore: CategoryStore
  loadableStores: LoadableStore[]

  constructor(
    entityTypeStore: EntityTypeStore,
    hyperMediaStore: HyperMediaStore,
    categoryStore: CategoryStore,
    ...loadableStores: LoadableStore[]
  ) {
    super()
    this.entityTypeStore = entityTypeStore
    this.hyperMediaStore = hyperMediaStore
    this.categoryStore = categoryStore
    this.loadableStores = loadableStores

    makeObservable(this)
  }

  @action
  async load() {
    this.state = LoadingState.LOADING
    await Promise.all([
      this.entityTypeStore.load(),
      this.hyperMediaStore.load(),
      this.categoryStore.load(),
      ...this.loadableStores.map((store) => store.load()),
    ])
    runInAction(() => {
      this.state = LoadingState.LOADED
    })
  }

  @override
  async unload() {
    await Promise.all(this.loadableStores.map((store) => store.unload()))
    runInAction(() => {
      this.state = LoadingState.NOT_LOADED
    })
  }

  @computed
  get ready() {
    return this.state === LoadingState.LOADED
  }
}
